<div>
  @let site = site$ | async;

  @if (site) {
    <aux-site-header [site]="site">
      <aux-route-tab-group
        className="px-4 pt-4 text-base ml-[10px]"
        [tabs]="tabs"
        [indexFn]="indexFn"
        variant="button"
      />
    </aux-site-header>
  }

  <div class="px-8 py-4">
    <router-outlet></router-outlet>
  </div>
</div>
